export default __webpack_public_path__ + "dc6cec3f5ca3b48de297b2eb40aad7ae.png";